export default __webpack_public_path__ + "static/media/icon_emerald.ff99d6cb.png";